//update cart trigger
$(function(){

    $('.js-trigger-cart-update').on('click', function(e){

        e.preventDefault();
        $('button[name="update_cart"]')[0].click();
        setTimeout(function(){
            window.location.reload();
        }, 600);

    });

})